import _ from 'underscore';
import RSVP from 'rsvp';
import $ from 'jquery';
import SessionStore from 'stores/shared/session';
import BookingRequestStore from 'stores/plugins/booking_request';
import { formatDateToISO8601, formatTimeTo24Hour } from 'lib/date_utils';

let previewRequest = null;

const PricingService = {
  buildGuidePreview(params) {
    return new RSVP.Promise((resolve, reject) => {
      previewRequest = $.ajax({
        url: '/api/pricing/guide_preview.json',
        type: 'POST',
        data: JSON.stringify(PricingService._guidePreviewParams(params)),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: resolve,
        error: reject,
      });
    });
  },

  buildPreview(params = null) {
    if (previewRequest && previewRequest.abort) {
      previewRequest.abort();
    }
    return new RSVP.Promise((resolve, reject) => {
      previewRequest = $.ajax({
        url: '/api/pricing/preview.json',
        type: 'POST',
        data: JSON.stringify(PricingService._previewParams(params)),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: resolve,
        error: reject,
      });
    });
  },

  _guidePreviewParams(params) {
    const processedParams = {
      tour_id: params.tour_id,
      units: params.units,
      addons: params.addons,
    };

    if (params.time_slot_date) {
      processedParams.time_slot_date = params.time_slot_date;
    }

    if (params.time_slot_start_time) {
      processedParams.time_slot_start_time = params.time_slot_start_time;
    }

    return processedParams;
  },

  _previewParams(params) {
    const addons = BookingRequestStore.state
      .get('addons')
      .toJS()
      .map((selectedAddon) => {
        // Super defensive code...for anywhere that we might still be passing around
        // God-forsaken guests instead of count...
        let count;
        if (selectedAddon && selectedAddon.count >= 0) {
          count = selectedAddon.count;
        } else if (selectedAddon && selectedAddon.guests >= 0) {
          count = selectedAddon.guests;
        } else {
          count = 0;
        }

        return {
          id: selectedAddon.id,
          count,
        };
      });

    const rawDate = BookingRequestStore.state.get('date');
    const rawTime = BookingRequestStore.state.get('time');
    const timeSlotDate = formatDateToISO8601(rawDate);

    // Get time from server-rendered props or store
    const timeValue = params?.time || rawTime;
    const timeSlotStartTime = timeValue ? formatTimeTo24Hour(timeValue) : null;

    return _.extend(
      {
        booking_id: params ? params.bookingId : null,
        pricing: {
          tour_id: BookingRequestStore.state.get('tour_id'),
          configuration: {
            units: BookingRequestStore.state.get('units').toJSON(),
            addons,
          },
          discount_code: BookingRequestStore.state.get('discount_code'),
          price_currency: SessionStore.state.get('currency'),
        },
      },
      {
        request_date: BookingRequestStore.state.get('date'),
        time_slot_date: timeSlotDate,
        time_slot_start_time: timeSlotStartTime,
      },
      SessionStore._getCSRFTokenObject()
    );
  },
};

export default PricingService;
